import styled from 'styled-components'
import { composeTheme } from '../../../utils/compose-theme'

export const Logo = styled.div`
  align-items: flex-start;
  display: flex;
  justify-content: center;
  margin-bottom: 3rem;
  margin-top: 3rem;
  min-height: 6rem;
`

export const WrapperImage = styled.div.attrs((props) => composeTheme(props))`
  cursor: pointer;
  height: ${(props) =>
    props.theme.collapsed ? 'auto' : props.theme.navbar.logoHeight};
  width: ${(props) =>
    props.theme.collapsed ? props.theme.navbar.logoWidth : 'auto'};
`
